import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../../../../../contexts/customerFormContext'

export const ContactEmail = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.email.label')}
      name="contactEmail"
      render={({ field }) => <Input {...field} size="sm" />}
    />
  )
}
